import React from "react";
import ReactDOM from "react-dom/client";

import "@/i18n/config";
import App from "./App";
import "./index.css";
import "./styles/wizard-step-transition.css";
import { captureAttributionToSession } from "@/lib/mag-analytics";

// Capture UTM params AND the Google click id (gclid / gbraid / wbraid) from the
// entry URL into sessionStorage before render, so the first analytics event of
// the session (e.g. wizard_started fired in an effect after mount) already sees
// them. Soft navigations preserve the captured values for the rest of the
// session — which is the point: the click id arrives on the entry URL once, and
// the events that matter most fire at the end of the wizard, several
// navigations later.
captureAttributionToSession();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
